import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List'
import ListItemText from '@material-ui/core/ListItemText';
//import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
//import Image from 'material-ui-image';
//import TarifCalendrier from './Tarif 2019.png';


//const win = Dimensions.get('window');

const styles = {
  root: {
        width: '100%',
    overflowX: 'auto',
      },
  table: {
        minWidth: 900,
      },
};

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    fontSize: 16,
    textAlign: "left",
  },
  body: {
    fontSize: 14,
    textAlign: "left",
    
  },
}))(TableCell);




function Tarif(props) {
  const { classes } = props;

  return (
    <div>
         <Grid container spacing={24}>

    <Grid item xs={12}>
    <Typography variant='title' gutterBottom align="left">
      Tarif
    </Typography>
    <Paper className={classes.root}>
    <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <CustomTableCell>Saison 2025</CustomTableCell>
            <CustomTableCell>Tarif Location semaine</CustomTableCell>
            {/* <CustomTableCell>Période</CustomTableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <CustomTableCell>Haute Saison </CustomTableCell>
            <CustomTableCell>à partir de 2170 €</CustomTableCell>
 {/*           <CustomTableCell> */}
             {/* <List> */}
                {/* <ListItemText disableTypography>  du 22 décembre 2023 au 8 janvier 2024</ListItemText> */}
                {/* <ListItemText disableTypography>  du 28 juin 2024 au 1er septembre 2024</ListItemText> */}
              {/* </List> */}
            {/* </CustomTableCell>  */}
          </TableRow>
          <TableRow>
            <CustomTableCell>Moyenne Saison</CustomTableCell>
            <CustomTableCell>à partir de 1350 €</CustomTableCell>
            {/* <CustomTableCell> */}
              {/* <List> */}
                {/* <ListItemText disableTypography> du 20 octobre 2023 au 6 novembre 2023</ListItemText> */}
                {/* <ListItemText disableTypography> du 9 février 2024 au 11 mars 2024</ListItemText> */}
                {/* <ListItemText disableTypography> du 5 avril 2024 au 28 juin 2024</ListItemText> */}
              {/* </List> */}
            {/* </CustomTableCell> */}
          </TableRow>
          <TableRow>
            <CustomTableCell>Basse Saison</CustomTableCell>
            <CustomTableCell>à partir de - €</CustomTableCell>
            {/* <CustomTableCell> */}
              {/* <List> */}
                {/* <ListItemText disableTypography> du 6 novembre 2023 au 22 décembre 2023</ListItemText> */}
                {/* <ListItemText disableTypography> du 8 janvier 2024 au 9 février 2024</ListItemText> */}
                {/* <ListItemText disableTypography> du 11 mars 2024 au 5 avril 2024</ListItemText> */}
              {/* </List> */}
            {/* </CustomTableCell> */}
          </TableRow>
        </TableBody>
      </Table>
      </Paper>
      </Grid>

<Grid item xs={12}>
    <Typography variant='title' gutterBottom align="left">
      Services
    </Typography>
    <Typography gutterBottom align="left">
      Ménage de fin de location : 150 euros (forfait appliqué à chaque séjour)
    </Typography>
    <Typography gutterBottom align="left">
      Les tarifs incluent la fourniture des draps et serviettes
    </Typography>
    <br/>
    <Typography variant='title' gutterBottom align="left">
      Conditions particulières
    </Typography>
    <Typography gutterBottom align="left">
      Taxe de séjour : 3,3% du coût de la nuitée par adulte dans la limite de 4,40 euros par personne et par jour
    </Typography>
    <Typography gutterBottom align="left">
      Dépôt de garantie : 900 euros
    </Typography>
    <Typography gutterBottom align="left">
      Arrhes à la réservation : 25% du montant de la location
    </Typography>
    <Typography gutterBottom align="left">
      Les charges (eau, gaz, électricité, chauffage, accès internet) sont incluses dans le montant de la location
    </Typography>
    <Typography gutterBottom align="left">
      Arrivées et départs : Les arrivées se font entre 16h et 20h et les départs entre 8h et 10h. Une arrivée tardive ou un départ anticipé peuvent donner lieu à une facturation supplémentaire de 30€
    </Typography>
    <br/>
    <br/>
    <Typography gutterBottom align="left">
      Numéro d'enregistrement : 3528800050193
    </Typography>
    <br/>

    </Grid>
  
    </Grid>
    </div>

  );
}




Tarif.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Tarif);


// WEBPACK FOOTER //
// ./src/Tarif.js